export default {
    addViolation: 'Добавить нарушение',
};
